import gql from 'graphql-tag';

export const getVisitorWatchlist = gql`
  query GetVisitorWatchlist(
    $visitorWatchlistId: String!
    $organizationId: String!
  ) {
    visitorWatchlist(
      visitorWatchlistId: $visitorWatchlistId
      organizationId: $organizationId
    ) {
      id
      organizationId
      visitorMatchingInfo {
        firstName {
          primaryValue
          alternateValues
          matchType
        }
        lastName {
          primaryValue
          alternateValues
          matchType
        }
        email {
          primaryValue
          alternateValues
          matchType
        }
        phone {
          primaryValue
          alternateValues
          matchType
        }
      }
      severityLevel
      notes
      attachmentIds
      reportedBy
      createdBy
      createdByName
      updatedBy
      updatedByName
      createdAt
      updatedAt
      tenantIds
      watchlistLevelConfig {
        id
        organizationId
        level
        displayLevelText
        isNotificationsEnabled
        notificationTargets
        isWatchlistDisplayed
        isApprovalRequired
      }
    }
  }
`;
